import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { MultiTenantOrganizationDetailsClientLoadAction } from '../../domains/multiTenantOrganizationDetails/actions.types';

import { MultiTenantOrganizationDetailsLifecycle } from './types';

const initialState: MultiTenantOrganizationDetailsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<MultiTenantOrganizationDetailsLifecycle, MultiTenantOrganizationDetailsClientLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MULTI_TENANT_ORGANIZATION_DETAILS.LOAD_PENDING':
      return setPending();
    case 'MULTI_TENANT_ORGANIZATION_DETAILS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'MULTI_TENANT_ORGANIZATION_DETAILS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
